<template>
  <div>
    <b-form-group
      class="input-group-var-linia-assistencial"
      label="Linia assistencial:"
      label-size="sm"
      label-for="input-var-linia-assistencial"
      label-cols="4"
    >
      <b-form-select
        required
        size="sm"
        id="input-var-linia-assistencial"
        class="var-linia-assistencial"
        v-model="liniaAssistencial"
        :options="opcionsLiniaAssistencial"
        @input="onUpdateLiniaAssistencial"
      >
        <template v-slot:first>
          <b-form-select-option :value="null">Totes</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableLiniaAssistencial",
  props: {
    initialValue: {
      required: true,
    },
  },
  data() {
    return {
      codiVariable: "linia-assistencial",
      liniaAssistencial: null,
      opcionsLiniaAssistencial: [
        { value: "HOS", text: this.$t("variables.liniaAssistencial.HOS") },
        { value: "AP", text: this.$t("variables.liniaAssistencial.AP") },
        { value: "URG", text: this.$t("variables.liniaAssistencial.URG") },
        { value: "AEA", text: this.$t("variables.liniaAssistencial.AEA") },
      ],
    };
  },
  computed: {
    returnValue() {
      let r = { codi: this.codiVariable };
      if (this.liniaAssistencial != null) {
        r.valor = this.liniaAssistencial;
      }

      return r;
    },
  },
  methods: {
    onUpdateLiniaAssistencial(newValue) {
      console.log(newValue);
      this.$emit("linia-assistencial", this.returnValue);
    },
  },
  mounted() {
    if (this.initialValue != null) {
      this.liniaAssistencial = this.initialValue.valor;
    }
  },
};
</script>

<style>
.var-linia-assistencial {
  width: 180px;
}
.input-group-var-linia-assistencial .col {
  text-align: left;
}
</style>
